// Tokens de agentes (superadmin). Globales o de un solo cliente.

import { createFileRoute, redirect } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { AgentTokenSettings } from '~/components/AgentTokenSettings/AgentTokenSettings';
import { OauthGrantSettings } from '~/components/OauthGrantSettings/OauthGrantSettings';
import { configRouteRedirect } from '~/lib/config-access';
import { currentUser } from '~/lib/pb';
import page from './_authed.clientes.module.css';

export const Route = createFileRoute('/_authed/configuracion/agentes')({
  beforeLoad: () => {
    const dest = configRouteRedirect(currentUser()?.role, '/configuracion/agentes');
    if (dest) throw redirect({ to: '/' });
  },
  component: AgentesPage,
});

function AgentesPage() {
  const me = currentUser();
  if (me?.role !== 'superadmin') {
    return (
      <div className={page.page}>
        <div className={page.notSuperadmin}>
          <ShieldAlert size={32} aria-hidden style={{ marginBottom: 12 }} />
          <p>El token de agentes es solo para superadmins.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={page.page}>
      <header className="page-header">
        <div className="page-header__titles">
          <h1 className="h2">Agentes</h1>
          <p className="page-header__subtitle">
            Tokens para operar Focus desde el MCP o con curl. Uno global ve todos los clientes; uno
            de cliente solo ve el suyo.
          </p>
        </div>
      </header>
      <AgentTokenSettings />
      <OauthGrantSettings />
    </div>
  );
}
